"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const listGenericTaggedValues_1 = require("./calls/listGenericTaggedValues");
//import { IGenericObject } from '../../Shared/Types';
class TVSClient {
    constructor(params) {
        this.header = {
            fragmentLanguage: 'Javascript',
            clientIdentifier: '',
            version: 2,
            fragmentVersion: '',
        };
        this.listGenericTaggedValues = listGenericTaggedValues_1.listGenericTaggedValues.bind(this);
        this.initializationParams = params;
    }
    async sendRequest(page, request) {
        //const requestString = JSON.stringify(request);
        const response = await axios_1.default
            .post(this.initializationParams.url + page, request, {
            headers: {
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            },
            withCredentials: false,
            proxy: false, // Disable default proxy behavior of Axios
            httpsAgent: this.initializationParams.httpsAgent,
        })
            .then((response) => response.data);
        return response;
    }
}
exports.default = TVSClient;
